import { render, staticRenderFns } from "./SignoutCallback.vue?vue&type=template&id=004cc9fb&"
import script from "./SignoutCallback.vue?vue&type=script&lang=js&"
export * from "./SignoutCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports